import { FacilitiesFilter } from '@gutwin-audit/shared/models/facilities-filter.model';

export class DashboardFilters {
  facilities: FacilitiesFilter;
  auditors: Array<string>;
  dateFrom: string;
  dateTo: string;
  auditTypes: Array<string>;

  constructor(filters?: Partial<DashboardFilters>) {
    if (filters) {
      this.facilities = filters.facilities;
      this.dateTo = filters.dateTo;
      this.dateFrom = filters.dateFrom;
      this.auditors = filters.auditors;
      this.auditTypes = filters.auditTypes;
    }
  }
}
